import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import {AuthModalService} from "../services/auth.modal.service";

@Injectable({
    providedIn: 'root'
})
export class AdminGuard implements CanActivate {

    constructor(private router: Router,
                private authModalService: AuthModalService) {}

    canActivate(): boolean {

        const role = localStorage.getItem('role');
        const token = sessionStorage.getItem('accessToken');

        if (token && role === 'ADMIN') {
            return true;
        }

        // ❌ Not admin → redirect
        this.router.navigate(['/']).then(() => {

            // Then open login popup
            this.authModalService.openLogin();
        });
        return false;
    }
}
